/**
 * Условные обозначения для оверлея-подсказки модалки правил.
 *
 * Перечень собран по фактическому использованию иконок в описаниях фракций
 * (FactionCardOverlay/descriptions) и политик (PolicyCardOverlay/descriptions) —
 * это ровно те значки, которые игрок встречает на карточках и о значении
 * которых ему негде спросить.
 *
 * Группа с механиками одной фракции задается через subGroups: заголовок
 * группы общий («Фракционные»), а подзаголовок называет фракцию. Обычные
 * группы остаются плоскими — просто items.
 *
 * Подписи взяты из title/alt тех же описаний. Там, где в исходниках подпись
 * очевидно скопирована от соседней иконки (гора подписана «Квартал», дорога —
 * «Крепость», победные очки — «Обменять»), в легенде стоит верное значение:
 * иначе подсказка вводила бы в заблуждение сильнее, чем ее отсутствие.
 */
import {MINUS_SIGN} from "../../../constants/text";

export const RULES_LEGEND_GROUPS = [
  {
    title: 'Строительство и ресурсы',
    items: [
      {src: '/img/icons/hammer brown.png', label: 'Строительство'},
      {src: '/img/icons/action.png', label: 'Действие в Фазе Строительства'},
      {
        src: '/img/icons/free action.png',
        label: 'Свободное действие (не учитывается лимитом действий в Фазе Строительства)'
      },
      {src: '/img/icons/coins.png', label: 'Монеты'},
      {src: '/img/icons/win points.png', label: 'Победные очки'},
      {src: '/img/icons/percent white.png', label: 'Скидка'},
      // {src: '/img/icons/up.png', label: 'Обмен одного на другое'}, // Излишне
      {src: '/img/icons/exclamation-mark.png', label: 'Важное ограничение'},
    ],
  },
  {
    title: 'Бой',
    items: [
      {src: '/img/icons/barracks red.png', label: 'Ближний бой'},
      {src: '/img/icons/shooting.png', label: 'Стрельба'},
      {src: '/img/icons/damage.png', label: 'Урон'},
      {src: '/img/icons/distance.png', label: 'Дальность'},
      {src: '/img/icons/dice.png', label: 'Бросок кости'},
      {src: '/img/icons/dice red.png', label: 'Бросок кости противника'},
      {src: '/img/icons/building_damage.png', label: 'Повреждение строения'},
      {src: '/img/icons/initiative.png', label: 'Инициатива (право первого хода в фазе)'},
    ],
  },
  {
    title: 'Отряды',
    items: [
      {
        src: '/img/icons/unit d6 friend.png',
        label: `Отряд игрока (любого типа) ${MINUS_SIGN} в общих формулировках`,
        isUnitIcon: true
      },
      {src: '/img/icons/unit d6 enemy.png', label: 'Отряд противника (любого типа)', isUnitIcon: true},
      {src: '/img/icons/unit size.png', label: 'Размер отряда'},
      {src: '/img/icons/supply.png', label: 'Снабжение'},
      {src: '/img/icons/speed.png', label: 'Перемещение'},
      {
        src: '/img/icons/unit d6 friend.png',
        label: `Пехота (макс. размер 6) ${MINUS_SIGN} рядом с другими типами отрядов`,
        isUnitIcon: true
      },
      {src: '/img/icons/unit d10 friend.png', label: 'Тяжёлая пехота (макс. размер 10)', isUnitIcon: true},
      {src: '/img/icons/unit d20 friend.png', label: 'Элитная пехота (макс. размер 20)', isUnitIcon: true},
      {src: '/img/icons/unit d8 friend.png', label: 'Лёгкая кавалерия (макс. размер 8)', isUnitIcon: true},
      {src: '/img/icons/unit d12 friend.png', label: 'Тяжёлая кавалерия (макс. размер 12)', isUnitIcon: true},
      {src: '/img/icons/unit d4 friend.png', label: 'Катапульта (макс. размер 4)', isUnitIcon: true},
    ],
  },
  {
    title: 'Ячейки поля',
    items: [
      {src: '/img/icons/cell.png', label: 'Пустая ячейка (без строений и ключевых точек)'},
      {src: '/img/icons/city.42008716.png', label: 'Город'},
      {src: '/img/icons/central quarter.7dd51bfd.png', label: 'Центральный квартал'},
      {src: '/img/hexes/quarter.f69660fa.png', label: 'Квартал'},
      {src: '/img/hexes/barracks.efab12f7.png', label: 'Казарма'},
      {src: '/img/hexes/farm.699e6dfc.png', label: 'Ферма'},
      {src: '/img/hexes/mine.ecae90cd.png', label: 'Рудник'},
      {src: '/img/hexes/super_mine.7a4a81f7.png', label: 'Великий рудник'},
      {src: '/img/icons/mine_exploration.9e85865b.png', label: 'Разведка рудника'},
      {src: '/img/hexes/ruins.65862e11.png', label: 'Руины'},
      {src: '/img/hexes/super_ruins.97515170.png', label: 'Великие руины'},
      {src: '/img/hexes/mountains/mountain_rock_1.862dc5c3.png', label: 'Гора'},
      {src: '/img/hexes/road.1f281346.png', label: 'Дорога'},
      {src: '/img/hexes/fortress_light.10136716.png', label: 'Крепость'},
    ],
  },
  {
    title: 'Специальные строения',
    items: [
      {src: '/img/hexes/special buildings/special building.c496c562.png', label: 'Специальное строение (любое)'},
      {src: '/img/hexes/special buildings/military camp.1216e2cd.png', label: 'Военный лагерь'},
      {src: '/img/hexes/special buildings/arsenal.7f5423b5.png', label: 'Арсенал'},
      {src: '/img/hexes/special buildings/temple.17c08b3d.png', label: 'Храм'},
      {src: '/img/hexes/special buildings/guild.ee26d2b8.png', label: 'Гильдия'},
      {src: '/img/hexes/special buildings/warehouse.adf397b3.png', label: 'Склад'},
      {src: '/img/hexes/special buildings/palace.4b9c923b.png', label: 'Дворец'},
      {src: '/img/hexes/special buildings/fortress button.6fed26ae.png', label: 'Крепость'},
      {
        src: '/img/icons/fortress_construction.897ca848.png',
        label: 'Крепость (недостроенная)',
        className: 'rules-legend_fortress-construction'
      },
    ],
  },
  {
    title: 'Фракционные',
    subGroups: [
      {
        title: 'Элементали',
        items: [
          {src: '/img/icons/element_wheat.png', label: 'Зерно (для строительства Ферм)'},
          {src: '/img/icons/element_fire.png', label: 'Огонь (для строительства Казарм)'},
          {src: '/img/icons/element_earth.png', label: 'Земля (для строительства Кварталов и Специальных строений)'},
        ],
      },
    ],
  },
];
